var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGreenArrowUp({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 24,
    viewBox: "0 0 27 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.30788 19C8.71342 19 8.23096 19.448 8.23096 20C8.23096 20.552 8.71342 21 9.30788 21H17.9233C18.5177 21 19.0002 20.552 19.0002 20C19.0002 19.448 18.5177 19 17.9233 19H9.30788Z",
    fill: "#72F238"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.6019 3C13.3262 3 13.0721 3.08601 12.861 3.28101C11.7841 4.28101 5.32362 10.281 4.24562 11.281C3.56823 11.911 4.02699 13 4.98653 13H8.2173L8.2173 16C8.2173 16.552 8.69976 17 9.29422 17H17.9096C18.5041 17 18.9865 16.552 18.9865 16V13H22.2173C23.1769 13 23.6701 11.911 22.9916 11.281L14.3762 3.28101C14.1651 3.08601 13.8776 3 13.6019 3Z",
    fill: "#72F238"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGreenArrowUp);
export default __webpack_public_path__ + "static/media/green-arrow-up.4f933ba0dad01e851c0466375abf31d7.svg";
export { ForwardRef as ReactComponent };